import local from './etc/local.json' with { type: 'json' };
import qa from './etc/qa.json' with { type: 'json' };
import prod from './etc/prod.json' with { type: 'json' };
import _ from "lodash";
import { applyLocalTunnelWebCfg } from './localTunnelUrls.js';

export function getProfile() {
    const { profile } = extractProfile(import.meta.env?.VITE_PB_APP_PROFILE || process.env.NEXT_PUBLIC_PROFILE)
    return profile ?? (typeof window === "undefined" ? process.env.PB_PROFILE : null);
}

export function getServiceProfile() {
    const { svcProfile } = extractProfile(import.meta.env?.VITE_PB_APP_PROFILE || process.env.NEXT_PUBLIC_PROFILE)
    return svcProfile ?? (typeof window === "undefined" ? process.env.SVC_PROFILE : process.env.NEXT_PUBLIC_SVC_PROFILE);
}

export function extractProfile(profileString) {
    if (!profileString) return { profile: null, svcProfile: null };

    const parts = profileString.split('-');
    return {
        profile: parts[0],
        svcProfile: parts.length > 1 ? parts[1] : null
    };
}

export function getConfig(profile, svcProfile) {
    profile = profile || getProfile()
    svcProfile = svcProfile || getServiceProfile()
    if(!svcProfile && profile === "local"){
        svcProfile = "a"
    }

    let cfg;
    if (profile === "qa") {
        cfg = qa;
    } else if (profile === "prod") {
        cfg = prod;
    } else if (profile === "prod:dev") {
        const localProd = _.cloneDeep(prod)
        localProd.poln.redirect_sign_in = local.poln.redirect_sign_in
        localProd.poln.redirect_sign_out = local.poln.redirect_sign_out
        cfg = localProd
    } else {
        cfg = local;
    }

    if (svcProfile) {
        cfg = _.cloneDeep(cfg)
        cfg.siteApi.apiUrl = `${cfg.siteApi.apiUrl}/${svcProfile}`
        cfg.poln.poln_api_base_url = `${cfg.poln.poln_api_base_url}/${svcProfile}`
        cfg.nf.poln_api_base_url = `${cfg.nf.poln_api_base_url}/${svcProfile}`
        // Stage connect hosts like "qa-connect-api…", not "localhost" (would become "local-ahost").
        if (profile !== 'local') {
            cfg.nf.connect_api_base_url = cfg.nf.connect_api_base_url.replace(
                profile,
                `${profile}-${svcProfile}`
            )
        }
        cfg.nf.web_socket_url = cfg.nf.web_socket_url + "/" + svcProfile
    }

    if (typeof window === 'undefined') {
        //console.log(`config from ${profile}-${svcProfile}`)
    }

    // Override kit.appInstallUrl with VITE_KIT_APP_ID from env (e.g. app/nf/.env.local)
    const kitAppId = import.meta.env?.VITE_KIT_APP_ID || process.env.VITE_KIT_APP_ID;

    if (kitAppId && cfg?.kit) {
        cfg = _.cloneDeep(cfg);
        cfg.kit.appInstallUrl = `https://app.kit.com/apps/${kitAppId}`;
    }

    // Override kit.clientId with VITE_KIT_CLIENT_ID from env (e.g. app/nf/.env.local)
    const kitClientId = import.meta.env?.VITE_KIT_CLIENT_ID || process.env.VITE_KIT_CLIENT_ID;

    if (kitClientId && cfg?.kit) {
        cfg = _.cloneDeep(cfg);
        cfg.kit.clientId = kitClientId;
    }

    // Override kit.mcp.clientId with VITE_KIT_MCP_CLIENT_ID from env
    const kitMcpClientId = import.meta.env?.VITE_KIT_MCP_CLIENT_ID || process.env.VITE_KIT_MCP_CLIENT_ID;
    if (kitMcpClientId && cfg?.kit) {
        cfg = _.cloneDeep(cfg);
        cfg.kit.mcp = cfg.kit.mcp || {};
        cfg.kit.mcp.clientId = kitMcpClientId;
    }

    // Override kit.mcp.appInstallUrl with VITE_KIT_MCP_APP_ID from env
    const kitMcpAppId = import.meta.env?.VITE_KIT_MCP_APP_ID || process.env.VITE_KIT_MCP_APP_ID;
    if (kitMcpAppId && cfg?.kit) {
        cfg = _.cloneDeep(cfg);
        cfg.kit.mcp = cfg.kit.mcp || {};
        cfg.kit.mcp.appInstallUrl = `https://app.kit.com/apps/${kitMcpAppId}`;
    }

    // Override extension.id with VITE_EXTENSION_ID from env (e.g. app/nf/.env.local)
    const extensionId = import.meta.env?.VITE_EXTENSION_ID || process.env.VITE_EXTENSION_ID;

    if (extensionId && cfg) {
        cfg = _.cloneDeep(cfg);
        cfg.extension = cfg.extension || {};
        cfg.extension.id = extensionId;
    }

    cfg = applyLocalTunnelWebCfg(cfg, profile, svcProfile, _.cloneDeep);

    // Override connect_api_base_url with VITE_CONNECT_API_BASE_URL from env
    const connectApiBaseUrl = import.meta.env?.VITE_CONNECT_API_BASE_URL || process.env.VITE_CONNECT_API_BASE_URL;

    if (connectApiBaseUrl && cfg) {
        cfg = _.cloneDeep(cfg);
        if (cfg.poln) cfg.poln.connect_api_base_url = connectApiBaseUrl;
        if (cfg.nf) cfg.nf.connect_api_base_url = connectApiBaseUrl;
        if (cfg.portal) cfg.portal.connect_api_base_url = connectApiBaseUrl;
    }

    return cfg;
}


export const cfg = getConfig();



